import EyeClose from "../../../../global components/Icons/EyeClose/EyeClose";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import s from "./Login.module.scss";
import clsx from "clsx";
import { Button, Input } from "antd";
import { useAppDispatch } from "../../../../libs/Utils/customHooks";
import { signIn } from "../../../../libs/redux/auth/signinSlice";
import { generatetoast } from "../../../../global components/Toast";
import { parseClientError } from "../../../../libs/api/Endpoints";
import EyeOpen from "../../../../global components/Icons/EyeOpen/EyeOpen";
import useDocumentTitle from "../../../../global components/PageTitle";
type Inputs = {
  email: string;
  password: string;
};
function Login() {
  useDocumentTitle("Admin | Login");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<Inputs>({ shouldFocusError: false });

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append("email", data.email.trimEnd());
    urlEncodedData.append("password", data.password.trimEnd());

    try {
      const result = await dispatch(signIn(urlEncodedData)).unwrap();

      if (result.message.includes("OTP")) {
        navigate(
          `/auth/verify-email?userId=${result.data.id}&email=${data.email}`,
          {
            state: {
              email: data.email.trimEnd(),
              password: data.password.trimEnd(),
            },
          },
        );
        return;
      }
      generatetoast(
        "success",
        result.message.charAt(0).toUpperCase() + result.message.slice(1),
      );
      navigate("/dashboard");
      reset();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.error || "error");
    }
  };
  return (
    <div className={s.wrapper}>
      <span className={s.titles}>
        <h3 className={s.title}>Admin Portal Login</h3>
        <p className={s.subtitle}>
          Please enter your details to access the Cloudivi admin portal.
        </p>
      </span>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={clsx(s.inputWrapper)}>
          <h5 className={clsx(s.inputLabel)}>Email address</h5>
          <input
            type="email"
            placeholder="admin@example.com"
            style={{
              backgroundColor: "white", // Set to your desired color
              boxShadow: "none",
            }}
            className={clsx(s.input, { [s.inputError]: errors.email })}
            {...register("email", { required: "Email is required" })}
          />
          {errors.email && (
            <span className={clsx(s.errorMessage)}>{errors.email.message}</span>
          )}
        </div>
        <div className={clsx(s.inputWrapper)}>
          <h5 className={clsx(s.inputLabel)}>Password</h5>
          <Controller
            name="password"
            control={control}
            rules={{
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters long",
              },
              // pattern: {
              //   value:
              //     /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#._])[A-Za-z\d@$!%*?&#._]{6,}$/,
              //   message:
              //     "Password must include at least one uppercase letter, one number, and one special character",
              // },
            }}
            render={({ field }) => (
              <Input.Password
                {...field} // Spread the field props here
                placeholder="Input password"
                style={{
                  backgroundColor: "white", // Your desired background color
                  boxShadow: "none",
                }}
                className={clsx(s.input, s.customPasswordInput, {
                  [s.inputPasswordError]: errors.password,
                })}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOpen fill="#6A6767" />
                  ) : (
                    <EyeClose fill="#6A6767" />
                  )
                }
              />
            )}
          />
          {errors.password && (
            <span className={clsx(s.errorMessage)}>
              {errors.password.message}
            </span>
          )}
        </div>

        <span className={s.forgot}>
          <Link to={"/auth/forgot-password"} className={clsx(s.links)}>
            Forgot your password?
          </Link>
        </span>
        <Button
          type="default"
          className={clsx(s.button)} // Button style
          htmlType="submit" // Ensures it's tied to form submission
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Log In
        </Button>
      </form>
    </div>
  );
}

export default Login;
